import { useProject, useSubTask } from "../../../hooks";
import { useTask } from "../../../hooks/query";
import { useEffect } from "react";

export default function useJobExecution(task: any) {
    const { useListSubtask } = useTask();
    const { project } = useProject();
    const { tasks, setTasks } = useSubTask();

    const listSubtaskSvc = useListSubtask();

    const fetchData = async () => {
        try {
            const params = { ProjectId: project?.id, TaskId: task.Id };
            const response = await listSubtaskSvc.mutateAsync(params);
            setTasks(response);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (project?.id && task.Id) {
            fetchData().then();
        }
    }, []);

    return { tasks };
}
